import axiosInstance, { createUrl } from ".";

export const getAuditInfo = async (params?: any): Promise<any | []> => {
  try {
    const result: any = await axiosInstance.get(
      createUrl("/api/v1/audit-log"),
      { params }
    );
    if (result.status === 200) return result?.data || [];
    return result;
  } catch (err: any) {
    console.log(">>>>>>>Error", err?.response?.data?.message[0]);
    throw err;
  } finally {
  }
};

export const getParticularAuditInfo = async (id: number): Promise<any> => {
  try {
    const result: any = await axiosInstance.get(
      createUrl("/api/v1/audit-log/" + id)
    );
    if (result.status === 200) return result?.data?.data || {};
    return result;
  } catch (err: any) {
    console.log(">>>>>>>Error", err?.response?.data?.message[0]);
    throw err;
  } finally {
  }
};
